import { AnyAction, Dispatch } from 'redux';
import { HealerBankDetailsGateway } from '../../../infra/adapters/luminara/healer-bank-details/bank-details-gateway';
import { HealerBankDetailsAction } from '../../../store/reducers/healer-bank-details.reducer';
import { AppState } from '../../../store/store';
import { BankDetails } from '../../models/healer-bank-details';
import { ThunkResult } from '../shared/ThunkResult';
import { showFailureNotificationAction } from '../shared/showFailureNotificationAction';
import { showSuccessNotificationAction } from '../shared/showSuccessNotificationAction';
import { loadMyBankDetailsAsHealer } from './load-healer-bank-details';

export const updateHealerBankDetails = (
  body: BankDetails
): ThunkResult<{
  healerBankDetailsGateway: HealerBankDetailsGateway;
}> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState, { healerBankDetailsGateway }) => {
    try {
      await healerBankDetailsGateway.updateHealerBankDetails(body);
      dispatch<any>(loadMyBankDetailsAsHealer());
      dispatch<any>(showSuccessNotificationAction('Bank details updated successfully'));
    } catch (error: any) {
      dispatch({ type: 'UPDATE_HEALER_BANK_DETAILS_FAILURE', payload: error } as HealerBankDetailsAction);
      dispatch<any>(showFailureNotificationAction('Bank details update failed'));
    }
  };
};
